import { isPlatformBrowser } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { LocalStorage } from './local-storage';

export interface SocialsInfo {
  link: string;
  displayText: string;
}

export interface DataConfig {
  email: string;
  phone: string;
  /** Derived `tel:` href for the phone number; single source of truth for all call CTAs. */
  phoneHref: string;
  /** Derived `mailto:` href for the email address; single source of truth for all email CTAs. */
  emailHref: string;
  paypalLink: string;
  paypalUsername: string;
  venmoLink: string;
  venmoUsername: string;
  cashAppLink: string;
  cashAppUsername: string;
  zelleLink: string;
  zelleUsername: string;
  facebook: SocialsInfo;
  instagram: SocialsInfo;
  youtube: SocialsInfo;
  linkedin: SocialsInfo;
  youtubeLessonsPlaylist: string;
}

export type DataConfigKey = keyof DataConfig;

export type SocialKey = 'facebook' | 'instagram' | 'youtube' | 'linkedin';

export const SOCIAL_KEYS: SocialKey[] = [
  'facebook',
  'instagram',
  'youtube',
  'linkedin',
] as const;

export function isSocialKey(key: string): key is SocialKey {
  return SOCIAL_KEYS.includes(key as SocialKey);
}

export const DATA_CONFIG = new InjectionToken<DataConfig>('Data Config');

export const GOOGLE_MAPS_EMBED_SRC_STUDIO_URL =
  new InjectionToken<SafeResourceUrl>('Google Maps Embed Src Studio URL');

export const LOCAL_STORAGE = new InjectionToken<Storage | null>(
  'LOCAL_STORAGE',
  {
    providedIn: 'root',
    factory: () => getStorage(inject(PLATFORM_ID)),
  },
);

const getStorage = (platformId: object): Storage | null => {
  // Prerendering: localStorage is undefined for prerender build
  return isPlatformBrowser(platformId) ? new LocalStorage() : null;
};
